
const ACTIONS = {
    INIT_API_HANDLER: "INIT_API_HANDLER",
    SUCCESSFUL: "SUCCESSFUL",
    FAILED: "FAILED",
    FAILED_WITH_FORM: "FAILED_WITH_FORM"
};

export default ACTIONS;